import { map as higherOrderMap } from 'rxjs/operators';
export function map(project, thisArg) {
    return higherOrderMap(project, thisArg)(this);
}
//# sourceMappingURL=map.js.map


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/node_modules/rxjs-compat/_esm5/operator/map.js
// module id = ../../../../rxjs-compat/_esm5/operator/map.js
// module chunks = vendor